// src/pages/ConfigPage.js — ಸರಳ ಆವೃತ್ತಿ (Teacher-friendly)
import React, { useState, useEffect } from "react";
import { groupAPI, menuAPI, configAPI } from "../api/api";
import { Modal, FormRow, ModalActions, ConfirmModal, NumInput } from "./ClassesPage";
import toast from "react-hot-toast";
import "./CommonPage.css";

const KN_DIGITS = "೦೧೨೩೪೫೬೭೮೯";
const toEnglish = (str) =>
  String(str).replace(/[೦-೯]/g, (d) => KN_DIGITS.indexOf(d));

// ಸರ್ಕಾರಿ ನಿಯಮ — reference only
const GOVT_NORMS = [
  { item:"ಅಕ್ಕಿ / ಗೋಧಿ",  lower:"100 ಗ್ರಾಂ", upper:"150 ಗ್ರಾಂ" },
  { item:"ತೊಗರಿ ಬೇಳೆ",   lower:"20 ಗ್ರಾಂ",  upper:"30 ಗ್ರಾಂ"  },
  { item:"ಎಣ್ಣೆ",         lower:"5 ml",       upper:"7.5 ml"    },
  { item:"ಉಪ್ಪು",         lower:"2 ಗ್ರಾಂ",   upper:"4 ಗ್ರಾಂ"  },
  { item:"ಹಾಲಿನ ಪುಡಿ",    lower:"18 ಗ್ರಾಂ",  upper:"18 ಗ್ರಾಂ" },
  { item:"ರಾಗಿ ಮಾಲ್ಟ್",   lower:"5 ಗ್ರಾಂ",   upper:"5 ಗ್ರಾಂ"  },
  { item:"ಮೊಟ್ಟೆ",        lower:"₹5.50",      upper:"₹5.50"     },
  { item:"ಬಾಳೆ ಹಣ್ಣು",    lower:"₹6.00",      upper:"₹6.00"     },
];

const BLANK_FORM = {
  group_id:"", item_id:"", qty_per_student:"", cost_per_unit:"",
  cost_unit_label:"", effective_from: new Date().toISOString().slice(0,10), notes:"",
};

// Unit display helper
function unitLabel(unit_type) {
  if (unit_type === "grams")  return "ಗ್ರಾಂ";
  if (unit_type === "ml")     return "ಮಿಲಿ";
  if (unit_type === "count")  return "ಸಂಖ್ಯೆ";
  if (unit_type === "rupees") return "ರೂ";
  return unit_type;
}

function unitCostLabel(unit_type) {
  if (unit_type === "grams")  return "ಪ್ರತಿ kg";
  if (unit_type === "ml")     return "ಪ್ರತಿ litre";
  if (unit_type === "count")  return "ಪ್ರತಿ ಸಂಖ್ಯೆ";
  if (unit_type === "rupees") return "ಪ್ರತಿ ರೂ";
  return "";
}

export default function ConfigPage() {
  const [groups,   setGroups]   = useState([]);
  const [items,    setItems]    = useState([]);
  const [configs,  setConfigs]  = useState([]);
  const [modal,    setModal]    = useState(null);
  const [selected, setSelected] = useState(null);
  const [form,     setForm]     = useState(BLANK_FORM);
  const [loading,  setLoading]  = useState(false);
  const [showNorms,setShowNorms]= useState(false);

  // Recalculate
  const [rcFromDate, setRcFromDate] = useState(new Date().toISOString().slice(0,10));
  const [rcToDate,   setRcToDate]   = useState(new Date().toISOString().slice(0,10));
  const [rcLoading,  setRcLoading]  = useState(false);
  const [showRc,     setShowRc]     = useState(false);

  const loadAll = () => {
    groupAPI.list().then(r=>setGroups(r.data.data||[])).catch(()=>{});
    menuAPI.list().then(r=>setItems(r.data.data||[])).catch(()=>{});
    configAPI.groupItems().then(r=>setConfigs(r.data.data||[])).catch(()=>{});
  };
  useEffect(()=>{ loadAll(); }, []);

  const closeModal = () => { setModal(null); setSelected(null); };

  const openAdd = (prefillGroupId) => {
    setSelected(null);
    setForm({...BLANK_FORM, group_id: prefillGroupId||""});
    setModal("form");
  };

  const openEdit = (cfg) => {
  setSelected(cfg);
  setForm({
    group_id: cfg.group_id,
    item_id: cfg.item_id,
    // ✅ trailing zeros ತೆಗೆದು — 20.000 → 20, 5.000 → 5
    qty_per_student: String(parseFloat(cfg.qty_per_student)),
    cost_per_unit: String(parseFloat(cfg.cost_per_unit)),
    cost_unit_label: cfg.cost_unit_label || "",
    effective_from: cfg.effective_from
      ? new Date(cfg.effective_from).toISOString().slice(0, 10)
      : new Date().toISOString().slice(0, 10),
    notes: cfg.notes || "",
    config_id: cfg.id,
  });
  setModal("form");
};

  const handleSave = async () => {
    if (!form.group_id || !form.item_id || !form.qty_per_student) {
      toast.error("ಗುಂಪು, ಆಹಾರ ಪದಾರ್ಥ ಮತ್ತು ಪ್ರಮಾಣ ಅಗತ್ಯ"); return;
    }
    const qty  = parseFloat(toEnglish(String(form.qty_per_student)));
    const cost = parseFloat(toEnglish(String(form.cost_per_unit)))||0;
    if (isNaN(qty)||qty<=0) { toast.error("ಸರಿಯಾದ ಪ್ರಮಾಣ ನಮೂದಿಸಿ"); return; }
    setLoading(true);
    try {
      const payload = {...form, qty_per_student:qty, cost_per_unit:cost};
      if (selected) payload.config_id = selected.id;
      await configAPI.setGroupItem(payload);
      toast.success(selected?"✅ ಅಪ್‌ಡೇಟ್ ಆಗಿದೆ":"✅ ಉಳಿಸಲಾಗಿದೆ");
      if (selected) setShowRc(true);
      closeModal(); loadAll();
    } catch(e) {
      toast.error(e.response?.data?.message||"ತಪ್ಪಾಗಿದೆ");
    } finally { setLoading(false); }
  };

  const handleDeleteConfig = async () => {
    if (!selected) return;
    setLoading(true);
    try {
      await configAPI.deleteGroupItem(selected.id);
      toast.success("ಅಳಿಸಲಾಗಿದೆ ✅");
      closeModal(); loadAll();
    } catch(e) {
      toast.error(e.response?.data?.message||"ತಪ್ಪಾಗಿದೆ");
    } finally { setLoading(false); }
  };

  const handleRecalculate = async () => {
    if (!rcFromDate || !rcToDate) { toast.error("ದಿನಾಂಕ ಆಯ್ಕೆ ಮಾಡಿ"); return; }
    setRcLoading(true);
    try {
      const token = localStorage.getItem("token");
      const dates = [];
      let cur = new Date(rcFromDate);
      const end = new Date(rcToDate);
      while (cur <= end) {
        dates.push(cur.toISOString().slice(0,10));
        cur.setDate(cur.getDate()+1);
      }
      let ok = 0;
      for (const date of dates) {
        const res = await fetch(`/api/attendance/recalculate/${date}`, {
          method:"POST",
          headers:{ Authorization:`Bearer ${token}`, "Content-Type":"application/json" }
        });
        const d = await res.json();
        if (d.success) ok++;
      }
      toast.success(`✅ ${ok} ದಿನದ ಲೆಕ್ಕ ಮರು-ಮಾಡಲಾಗಿದೆ`);
      setShowRc(false);
    } catch { toast.error("ಮರು-ಲೆಕ್ಕ ತಪ್ಪಾಗಿದೆ"); }
    finally { setRcLoading(false); }
  };

  const byGroup = groups.map(g=>({
    ...g,
    configs: configs.filter(c=>c.group_id===g.id)
  }));

  return (
    <div className="common-page">

      {/* ── HEADER ── */}
      <div className="page-header">
        <h1 className="page-title">⚙️ ಆಹಾರ ಪ್ರಮಾಣ ಸಂರಚನೆ</h1>
        <p className="page-desc">ಪ್ರತಿ ಮಗುವಿಗೆ ಎಷ್ಟು ಆಹಾರ ನೀಡಬೇಕು — ಇಲ್ಲಿ ನಿಗದಿ ಮಾಡಿ</p>
      </div>

      {/* ── RECALCULATE BANNER ── */}
      {showRc && (
        <div style={{
          background:"rgba(251,191,36,0.08)", border:"1px solid rgba(251,191,36,0.35)",
          borderRadius:14, padding:"16px 18px", marginBottom:18
        }}>
          <div style={{ fontSize:14, color:"#fde047", fontWeight:700, marginBottom:6 }}>
            ⚠️ ಸಂರಚನೆ ಬದಲಾಯಿತು — ಹಳೆಯ ಲೆಕ್ಕ ಮರು-ಮಾಡಬೇಕೇ?
          </div>
          <div style={{ fontSize:12, color:"rgba(255,255,255,0.45)", marginBottom:12 }}>
            ಯಾವ ದಿನಾಂಕದಿಂದ ಯಾವ ದಿನಾಂಕದವರೆಗೆ ಮರು-ಲೆಕ್ಕ ಮಾಡಬೇಕು?
          </div>
          <div style={{ display:"flex", gap:10, flexWrap:"wrap", alignItems:"flex-end" }}>
            <div>
              <div style={{ fontSize:11, color:"#9ca3af", marginBottom:4 }}>ಪ್ರಾರಂಭ</div>
              <input type="date" value={rcFromDate} onChange={e=>setRcFromDate(e.target.value)}
                style={inputStyle} />
            </div>
            <div>
              <div style={{ fontSize:11, color:"#9ca3af", marginBottom:4 }}>ಅಂತ್ಯ</div>
              <input type="date" value={rcToDate} onChange={e=>setRcToDate(e.target.value)}
                style={inputStyle} />
            </div>
            <button onClick={handleRecalculate} disabled={rcLoading} style={rcBtnStyle}>
              {rcLoading ? "⏳ ಮರು-ಲೆಕ್ಕ..." : "🔄 ಮರು-ಲೆಕ್ಕ ಮಾಡಿ"}
            </button>
            <button onClick={()=>setShowRc(false)} style={cancelBtnStyle}>ಬೇಡ</button>
          </div>
        </div>
      )}

      {/* ── MANUAL RECALCULATE TRIGGER ── */}
      {!showRc && (
        <div style={{ marginBottom:16, display:"flex", justifyContent:"flex-end" }}>
          <button onClick={()=>setShowRc(true)} style={manualRcStyle}>
            🔄 ಹಳೆಯ ದಾಖಲೆ ಮರು-ಲೆಕ್ಕ ಮಾಡಿ
          </button>
        </div>
      )}

      {/* ── GOVT NORMS (collapsible) ── */}
      <div style={normsCardStyle}>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between",
                      cursor:"pointer" }} onClick={()=>setShowNorms(!showNorms)}>
          <span style={{ fontSize:13, fontWeight:700, color:"#fde047" }}>
            📋 ಸರ್ಕಾರಿ ನಿಯಮ 2025-26 (ಉಲ್ಲೇಖ)
          </span>
          <span style={{ color:"#fde047", fontSize:12 }}>{showNorms?"▲ ಮರೆ ಮಾಡಿ":"▼ ತೋರಿಸಿ"}</span>
        </div>
        {showNorms && (
          <div style={{ marginTop:12, display:"grid",
                        gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:8 }}>
            {GOVT_NORMS.map((n,i)=>(
              <div key={i} style={normRowStyle}>
                <div style={{ fontSize:12, fontWeight:600, color:"#e5e7eb", marginBottom:4 }}>
                  {n.item}
                </div>
                <div style={{ display:"flex", gap:6 }}>
                  <span style={normBadgeGreen}>೧-೫: {n.lower}</span>
                  <span style={normBadgeBlue}>೬-೧೦: {n.upper}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── MAIN CONFIG SECTIONS ── */}
      {byGroup.length === 0 && (
        <div style={{ textAlign:"center", padding:"3rem", color:"rgba(255,255,255,0.3)",
                      fontSize:14 }}>
          ಮೊದಲು "ತರಗತಿ / ಗುಂಪು" ಪೇಜ್‌ನಲ್ಲಿ ಗುಂಪು ಮಾಡಿ
        </div>
      )}

      {byGroup.map(g=>(
        <div key={g.id} style={groupSectionStyle}>

          {/* Group header */}
          <div style={groupHeaderStyle}>
            <div style={{ display:"flex", alignItems:"center", gap:10 }}>
              <span style={groupDotStyle}/>
              <span style={{ fontSize:15, fontWeight:700, color:"#86efac" }}>
                {g.name_kannada}
              </span>
              <span style={{ fontSize:12, color:"#6b7280" }}>
                ({g.configs.length} ಆಹಾರ ಪದಾರ್ಥ)
              </span>
            </div>
            <button style={addBtnStyle} onClick={()=>openAdd(g.id)}>
              + ಹೊಸ ಪದಾರ್ಥ ಸೇರಿಸಿ
            </button>
          </div>

          {/* Config cards */}
          {g.configs.length === 0 ? (
            <div style={emptyStyle}>
              ಇನ್ನೂ ಯಾವ ಆಹಾರ ಪದಾರ್ಥ ಸೇರಿಸಿಲ್ಲ — "+ ಹೊಸ ಪದಾರ್ಥ ಸೇರಿಸಿ" ಒತ್ತಿ
            </div>
          ) : (
            <div style={{ display:"grid",
                          gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",
                          gap:12, padding:"4px 0" }}>
              {g.configs.map(cfg=>(
                <div key={cfg.id} style={cfgCardStyle}>

                  {/* Item name */}
                  <div style={{ fontSize:16, fontWeight:700, color:"#f9fafb",
                                marginBottom:12 }}>
                    {cfg.item_name_kannada}
                    <span style={{ fontSize:11, color:"#6b7280", marginLeft:6,
                                   fontWeight:400 }}>
                      ({cfg.unit_type})
                    </span>
                  </div>

                  {/* Qty and Cost — big clear display */}
                  <div style={{ display:"flex", gap:8, marginBottom:12 }}>
                    <div style={infoBoxStyle}>
                      <div style={{ fontSize:11, color:"#9ca3af", marginBottom:2 }}>
                        ಪ್ರತಿ ಮಗುವಿಗೆ
                      </div>
                      <div style={{ fontSize:20, fontWeight:800, color:"#4ade80" }}>
                        {Number(parseFloat(cfg.qty_per_student))} {unitLabel(cfg.unit_type)}
                      </div>
                      <div style={{ fontSize:11, color:"#6b7280" }}>
                        {unitLabel(cfg.unit_type)}
                      </div>
                    </div>
                    <div style={infoBoxStyle}>
                      <div style={{ fontSize:11, color:"#9ca3af", marginBottom:2 }}>
                        ಬೆಲೆ
                      </div>
                      <div style={{ fontSize:20, fontWeight:800, color:"#fbbf24" }}>
                        ₹{parseFloat(cfg.cost_per_unit).toFixed(2)}
                      </div>
                      <div style={{ fontSize:11, color:"#6b7280" }}>
                        {cfg.cost_unit_label || unitCostLabel(cfg.unit_type)}
                      </div>
                    </div>
                  </div>

                  {/* Per day calculation preview */}
                  <div style={previewStyle}>
                    💡 10 ಮಕ್ಕಳಿಗೆ:{" "}
                    <strong style={{ color:"#4ade80" }}>
                      {cfg.unit_type==="grams"
                        ? `${(parseFloat(cfg.qty_per_student)*10/1000).toFixed(3)} kg`
                        : cfg.unit_type==="ml"
                        ? `${(parseFloat(cfg.qty_per_student)*10/1000).toFixed(3)} L`
                        : cfg.unit_type==="count"
                        ? `${parseFloat(cfg.qty_per_student)*10} ಸಂ`
                        : `₹${(parseFloat(cfg.qty_per_student)*10).toFixed(2)}`
                      }
                    </strong>
                    {" · "}
                    <strong style={{ color:"#fbbf24" }}>
                      ₹{
                        cfg.unit_type==="grams"
                          ? ((parseFloat(cfg.qty_per_student)*10/1000)*parseFloat(cfg.cost_per_unit)).toFixed(2)
                          : cfg.unit_type==="ml"
                          ? ((parseFloat(cfg.qty_per_student)*10/1000)*parseFloat(cfg.cost_per_unit)).toFixed(2)
                          : cfg.unit_type==="count"
                          ? (parseFloat(cfg.qty_per_student)*10*parseFloat(cfg.cost_per_unit)).toFixed(2)
                          : (parseFloat(cfg.qty_per_student)*10*parseFloat(cfg.cost_per_unit)).toFixed(2)
                      }
                    </strong>
                  </div>

                  {/* Actions */}
                  <div style={{ display:"flex", gap:8, marginTop:12 }}>
                    <button style={editBtnStyle} onClick={()=>openEdit(cfg)}>
                      ✏️ ಬದಲಾಯಿಸಿ
                    </button>
                    <button style={delBtnStyle}
                      onClick={()=>{ setSelected(cfg); setModal("deleteConfig"); }}>
                      🗑️
                    </button>
                  </div>

                </div>
              ))}
            </div>
          )}
        </div>
      ))}

      {/* ── ADD/EDIT MODAL ── */}
      {modal==="form" && (
        <Modal title={selected?"ಸಂರಚನೆ ಬದಲಾಯಿಸಿ":"ಹೊಸ ಸಂರಚನೆ"} onClose={closeModal} wide>

          {selected && (
            <div style={{ background:"rgba(74,222,128,0.08)",
                          border:"1px solid rgba(74,222,128,0.2)",
                          borderRadius:10, padding:"10px 14px",
                          marginBottom:14, fontSize:13, color:"#86efac" }}>
              ✏️ ಬದಲಾಯಿಸುತ್ತಿರುವುದು:{" "}
              <strong>{selected.group_name_kannada}</strong> →{" "}
              <strong>{selected.item_name_kannada}</strong>
            </div>
          )}

          <FormRow label="ಗುಂಪು *">
            <select className="modal-input" value={form.group_id}
              onChange={e=>setForm(p=>({...p,group_id:e.target.value}))}
              disabled={!!selected}>
              <option value="">— ಯಾವ ಗುಂಪಿಗೆ? —</option>
              {groups.map(g=><option key={g.id} value={g.id}>{g.name_kannada}</option>)}
            </select>
          </FormRow>

          <FormRow label="ಆಹಾರ ಪದಾರ್ಥ *">
            <select className="modal-input" value={form.item_id}
              onChange={e=>setForm(p=>({...p,item_id:e.target.value}))}
              disabled={!!selected}>
              <option value="">— ಯಾವ ಪದಾರ್ಥ? —</option>
              {items.map(i=>(
                <option key={i.id} value={i.id}>
                  {i.name_kannada} ({unitLabel(i.unit_type)})
                </option>
              ))}
            </select>
          </FormRow>

          {/* Qty hint based on selected item */}
          <FormRow label="ಪ್ರತಿ ಮಗುವಿಗೆ ಎಷ್ಟು? *"
            hint={
              items.find(i=>String(i.id)===String(form.item_id))?.unit_type === "grams"
                ? "(ಗ್ರಾಂ ನಲ್ಲಿ — ಉದಾ: 100)"
                : items.find(i=>String(i.id)===String(form.item_id))?.unit_type === "ml"
                ? "(ml ನಲ್ಲಿ — ಉದಾ: 5)"
                : "(ಸಂಖ್ಯೆ ನಲ್ಲಿ — ಉದಾ: 1)"
            }>
            <NumInput value={form.qty_per_student}
              onChange={v=>setForm(p=>({...p,qty_per_student:v}))}
              placeholder="ಉದಾ: 100 ಅಥವಾ ೧೦೦" />
          </FormRow>

          <FormRow label="ಬೆಲೆ (₹)" hint="(ಪ್ರತಿ kg / litre / ಸಂಖ್ಯೆ)">
            <NumInput value={form.cost_per_unit}
              onChange={v=>setForm(p=>({...p,cost_per_unit:v}))}
              placeholder="ಉದಾ: 40" />
          </FormRow>

          <FormRow label="ದಿನಾಂಕದಿಂದ ಚಾಲ್ತಿ">
            <input className="modal-input" type="date" value={form.effective_from}
              onChange={e=>setForm(p=>({...p,effective_from:e.target.value}))} />
          </FormRow>

          <ModalActions loading={loading} onSave={handleSave} onCancel={closeModal}
            saveLabel={selected?"✅ ಅಪ್‌ಡೇಟ್ ಮಾಡಿ":"✅ ಉಳಿಸಿ"} />
        </Modal>
      )}

      {/* ── DELETE CONFIRM ── */}
      {modal==="deleteConfig" && selected && (
        <ConfirmModal
          title="ಸಂರಚನೆ ಅಳಿಸಿ"
          message={`"${selected.group_name_kannada} — ${selected.item_name_kannada}" ಅಳಿಸುವಿರಾ?`}
          onConfirm={handleDeleteConfig}
          onCancel={closeModal}
          loading={loading}
        />
      )}

    </div>
  );
}

// ── STYLES ──────────────────────────────────────────────────
const inputStyle = {
  background:"#1a2332", border:"1px solid rgba(255,255,255,0.15)",
  color:"#e5e7eb", borderRadius:8, padding:"7px 10px", fontSize:13
};
const rcBtnStyle = {
  padding:"8px 18px", borderRadius:8, fontSize:13, fontWeight:700,
  cursor:"pointer", background:"rgba(251,191,36,0.15)",
  border:"1px solid rgba(251,191,36,0.4)", color:"#fde047"
};
const cancelBtnStyle = {
  padding:"8px 14px", borderRadius:8, fontSize:12, cursor:"pointer",
  background:"transparent", border:"1px solid rgba(255,255,255,0.1)", color:"#6b7280"
};
const manualRcStyle = {
  padding:"6px 14px", borderRadius:8, fontSize:12, cursor:"pointer",
  background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.1)",
  color:"#9ca3af"
};
const normsCardStyle = {
  background:"rgba(251,191,36,0.05)", border:"1px solid rgba(251,191,36,0.2)",
  borderRadius:12, padding:"12px 16px", marginBottom:20
};
const normRowStyle = {
  background:"rgba(255,255,255,0.03)", borderRadius:8, padding:"10px 12px"
};
const normBadgeGreen = {
  fontSize:11, padding:"2px 8px", borderRadius:6,
  background:"rgba(74,222,128,0.15)", color:"#86efac"
};
const normBadgeBlue = {
  fontSize:11, padding:"2px 8px", borderRadius:6,
  background:"rgba(96,165,250,0.15)", color:"#93c5fd"
};
const groupSectionStyle = {
  background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.07)",
  borderRadius:14, padding:"16px 18px", marginBottom:20
};
const groupHeaderStyle = {
  display:"flex", alignItems:"center", justifyContent:"space-between",
  marginBottom:16, flexWrap:"wrap", gap:8
};
const groupDotStyle = {
  width:10, height:10, borderRadius:"50%",
  background:"#4ade80", display:"inline-block"
};
const addBtnStyle = {
  padding:"7px 16px", borderRadius:8, fontSize:13, fontWeight:600,
  cursor:"pointer", background:"rgba(74,222,128,0.12)",
  border:"1px solid rgba(74,222,128,0.35)", color:"#4ade80"
};
const emptyStyle = {
  textAlign:"center", padding:"24px", color:"rgba(255,255,255,0.3)",
  fontSize:13, fontStyle:"italic",
  border:"1px dashed rgba(255,255,255,0.1)", borderRadius:10
};
const cfgCardStyle = {
  background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.09)",
  borderRadius:12, padding:"16px"
};
const infoBoxStyle = {
  flex:1, background:"rgba(255,255,255,0.04)", borderRadius:10,
  padding:"10px 12px", textAlign:"center"
};
const previewStyle = {
  background:"rgba(255,255,255,0.03)", borderRadius:8,
  padding:"8px 10px", fontSize:12, color:"#9ca3af"
};
const editBtnStyle = {
  flex:1, padding:"7px 10px", borderRadius:8, fontSize:12,
  fontWeight:600, cursor:"pointer",
  background:"rgba(96,165,250,0.1)", border:"1px solid rgba(96,165,250,0.25)",
  color:"#93c5fd"
};
const delBtnStyle = {
  padding:"7px 10px", borderRadius:8, fontSize:12, cursor:"pointer",
  background:"rgba(248,113,113,0.08)", border:"1px solid rgba(248,113,113,0.2)",
  color:"#f87171"
};